<template>
    <div class="Summary">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>Child Info</h4>
                        <p><span class="bold">Name: </span><span>{{ ChildRecordData.Client.Person.FirstName }}</span> <span v-if="ChildRecordData.Client.Person.AKA">"{{ ChildRecordData.Client.Person.AKA }}"</span> <span>{{ ChildRecordData.Client.Person.LastName }}</span></p>
                        <p><span class="bold">DOB: </span><span>{{ formatDate(ChildRecordData.Client.Person.DOB, 'MM/DD/YY') }}</span></p>
                        <p><span class="bold">Age: </span><span>{{ ChildRecordData.Client.Person.AgeString }}</span></p>
                        <p><span class="bold">Sex: </span><span>{{ ChildRecordData.Client.Person.Sex.Name }}</span></p>
                    </div>

                </div>
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>Location</h4>
                        <div v-if="IsPNWILS == false && CurrentLivingSituation != null">
                            <p><span class="bold">Name: </span><span>{{ CurrentLivingSituation.Residence.Name }}</span></p>
                            <p><span class="bold">Address: </span><span>{{ CurrentLivingSituation.Residence.Address.AddressSingleLine }} </span><GoogleMapsLink v-bind:address="CurrentLivingSituation.Residence.Address" /></p>
                        </div>
                        <div v-else-if="IsPNWILS == true && CurrentLivingSituation != null">
                            <p><span class="bold">Situation Type: </span><span>{{ CurrentLivingSituation.SituationType + ' (' + CurrentLivingSituation.InformalDescription + ')' }}</span></p>
                            <p><span class="bold">Address: </span><span>{{ CurrentLivingSituation.Address.AddressSingleLine }} </span><GoogleMapsLink v-bind:address="CurrentLivingSituation.Address" /></p>
                        </div>
                        <div v-else>
                            <p><span class="bold red">No Housing Assignment.</span></p>
                        </div>
                    </div>

                </div>
                
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>Program Enrollment</h4>
                        <p><span class="bold">Regional Program: </span><span>{{ ChildRecordData.SubProgram.Name }}</span></p>
                        <p><span class="bold">Placement Agency: </span><span>{{ ChildRecordData.PlacementAgency.Name }} </span></p>
                        <p><span class="bold">Referral: </span><span>{{ formatDate(ChildRecordData.StartDate, 'MM/DD/YY') }}</span></p>
                        <p><span class="bold">Termination: </span><span>{{ formatDate(ChildRecordData.EndDate, 'MM/DD/YY', '') }}</span></p>
                    </div>

                </div>
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>People</h4>
                        <div v-for="contact in ChildRecordData.Contacts.filter(x => x.EndDate == null)">
                            <p class="bold">{{contact.EntityContact.Person.FullName}}, {{ contact.ContactRelationship }}</p>
                            <p>{{contact.EntityContact.Person.Email}}</p>
                            <p v-for="pn in contact.EntityContact.Person.PhoneNumbers.filter(x => x.EndDate == null)">{{pn.PhoneNumber.FormattedPhoneNumber}}</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GoogleMapsLink from "../../../Core/LinkShortcuts/GoogleMapsLink.vue";
    export default {
        props: [
            'ChildRecordData'
        ],
        data: function () {
            return {
                
            }
        },
        methods: {
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            
        },
        components: {
            GoogleMapsLink
        },
        mounted() {
        },
        computed: {
           
            CurrentLivingSituation: function () {
                if (this.IsPNWILS == false) {
                    let livingSituations = this.ChildRecordData.ResidenceMemberships.filter(r => r.EndDate == null);
                    if (livingSituations.length == 1) {
                        return livingSituations[0];
                    } else {
                        return null;
                    }
                } else {
                    let livingSituations = this.ChildRecordData.LivingSituations.filter(r => r.EndDate == null);
                    if (livingSituations.length == 1) {
                        return livingSituations[0];
                    } else {
                        return null;
                    }
                }
                

            },
            IsPNWILS: function () {
                if (this.ChildRecordData.SubProgramID.toUpperCase() == "EBDA4D2B-FD9C-4135-804E-5132296063CA") {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }
</script>

<style scoped>
</style>